import { Itinerary as ItineraryType } from '@model/iceberg/common';
import React from 'react';
import { Item } from '@components/common/timeline/itinerary/item/Item';
import BaseTimeLines from '../base/BaseTimeLine';
import { Title } from './title/Title';
import { SectionTitle } from '@components/common/section-title';
import { AlternativeItineraryNote } from '@components/common/timeline/itinerary/AlternativeItineraryNote';

export interface ItineraryTimeLineProps {
  items: Array<ItineraryType>;
  heading: string;
}

export const ItineraryTimeLine = ({ items, heading }: ItineraryTimeLineProps) => {
  const renderTitle = ({ dayNo, length }: ItineraryType) => <Title dayNo={dayNo} length={length} />;
  const renderBody = (itinerary: ItineraryType) => <Item item={itinerary} />;
  return (
    <>
      <SectionTitle heading={heading} />
      <AlternativeItineraryNote />
      <BaseTimeLines items={items} renderTitle={renderTitle} renderBody={renderBody} collapsedHeight={600} />
    </>
  );
};
